export default __webpack_public_path__ + "static/media/polaroid6.e5af1394.jpg";